import { IAuthWidgetEventMap } from './types';

export function dispatchWidgetEvent<EventName extends keyof IAuthWidgetEventMap>(
  eventTarget: EventTarget | null,
  eventName: EventName,
  detail?: IAuthWidgetEventMap[EventName],
): void {
  eventTarget?.dispatchEvent(
    new CustomEvent<IAuthWidgetEventMap[EventName]>(eventName, { detail, bubbles: true, cancelable: false }),
  );
}
